/** @file Pure union of skins in order (later wins) without adding the default skin. */
import { skinAt } from '../_internal/skinAt';
import type { SkeletonData, SkinData } from '../skeletonData';

/** Copies every slot -> placeholder -> attachment entry of skin into map, overwriting earlier ones. */
function mergeInto(map: Map<number, Map<number, number>>, skin: SkinData): void {
  for (const [slot, entries] of skin.map) {
    let target = map.get(slot);
    if (target === undefined) {
      target = new Map<number, number>();
      map.set(slot, target);
    }
    for (const [placeholder, attachment] of entries) target.set(placeholder, attachment);
  }
}

/** Union of the given skins; a fresh SkinData named "a+b+…"; NOT_FOUND at skins[i] for an unknown index. */
export function combineSkins(data: SkeletonData, skins: number[]): SkinData {
  const map = new Map<number, Map<number, number>>();
  const names: string[] = [];
  for (const [i, index] of skins.entries()) {
    const skin = skinAt(data, index, `skins[${i}]`);
    names.push(skin.name);
    mergeInto(map, skin);
  }
  return { name: names.join('+'), map };
}
